/**
 * Tab-scoped JWT storage so each browser tab can hold a different logged-in account.
 * Legacy: tokens were stored in localStorage (shared across tabs).
 *
 * On first load, if this tab has no session tokens but localStorage still has the old
 * keys, we copy into sessionStorage and remove them from localStorage (one-time per tab).
 */

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

export function getAccessToken() {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setAccessToken(token) {
    if (token) {
        sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
    } else {
        sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    }
}

export function setRefreshToken(token) {
    if (token) {
        sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
        sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    }
}

/**
 * @param {{ access: string, refresh?: string|null }} tokens
 */
export function setSessionTokens({ access, refresh }) {
    setAccessToken(access);
    if (refresh !== undefined) {
        setRefreshToken(refresh || null);
    }
}

export function clearSessionTokens() {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}

/** Remove any leftover JWT keys from the pre–tab-scoped era (shared across tabs). */
export function clearLegacyJwtLocalStorage() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function migrateLegacyJwtFromLocalStorageIfNeeded() {
    if (sessionStorage.getItem(ACCESS_TOKEN_KEY)) {
        return;
    }
    const access = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (!access) {
        return;
    }
    const refresh = localStorage.getItem(REFRESH_TOKEN_KEY);
    sessionStorage.setItem(ACCESS_TOKEN_KEY, access);
    if (refresh) {
        sessionStorage.setItem(REFRESH_TOKEN_KEY, refresh);
    }
    clearLegacyJwtLocalStorage();
}

migrateLegacyJwtFromLocalStorageIfNeeded();
